import React from 'react';
import { observer } from "mobx-react";
import moment from 'moment'

import HighchartWithLoadingSpinner from './HighchartWithLoadingSpinner';
import FigureCaption from '../components/FigureCaption';
import {stateDailySmokeStore, regionDailySmokeStore} from '../store/apiStores'


function createSeriesData(data) {
    var seriesData = {
        'name': 'Smoke Coverage',
        'data': [{
            'name': 'heavy smoke',
            'color': '#525252',
            'data': []
        },{
            'name': 'medium smoke',
            'color': '#737373',
            'data': []
        }, {
            'name': 'light smoke',
            'color': '#969696',
            'data': []
        }]
    }
    if (data) {
        data.forEach(function(v){
            let date = parseInt(moment.utc(v.local_date).format('x'))
            seriesData.data[0].data.push([date, v.proportion_heavy*100])
            seriesData.data[1].data.push([date, v.proportion_medium*100])
            seriesData.data[2].data.push([date, v.proportion_light*100])
        });
        Object.values(seriesData.data).forEach((e)=>{e.data.sort()})
    }
    return seriesData;
}

function thirtydaysago(data) {
    if (!data || data.length == 0 || !data[0].data || data[0].data.length == 0) {
        // data hasn't loaded yet
        return null;
    }
    let last_dates = []
    data.forEach(function(v){
        v.data.sort()
        last_dates.push(v.data[v.data.length - 1][0])
    });
    let last_day = Math.max(...last_dates)
    return(last_day - ((24*60*60*1000) * 30))
}

export default observer(function StateSmokeSpline(props) {
    let storeData = (props.state)
        ? (stateDailySmokeStore.data)
        : (regionDailySmokeStore.data);
    let seriesData = createSeriesData(storeData);

    let titleText = (props.state)
        ? (`${props.state} State HMS Smoke Plume Coverage`)
        : (`${props.region} Region HMS Smoke Plume Coverage`);

    let subtitleText = (props.state)
        ? (`% of state covered`)
        : (`% of region covered`);

    let options = {
        chart: {
            type: 'areaspline',
            zoomType: 'x'
        },

        title: {
            useHTML: true,
            text: titleText,
            align: 'left'
        },

        subtitle: {
            text: subtitleText,
            align: 'left'
        },

        time: {
            useUTC: true
        },

        yAxis: {
            opposite: true,
            max: 100,
            min: 0,
            title: {
                enabled: false
            },
            labels: {
                format: '{value}%'
            }
        },

        xAxis: {
            type: 'datetime',
            xDateFormat: '%b %d %Y at %l%p',
        },

        legend: {
            align: 'center',
            verticalAlign: 'bottom',
            x: 0,
            y: 0
        },

        tooltip: {
            shared: true,
            valueSuffix: '%',
            valueDecimals: 1
        },

        plotOptions: {
            series: {
                label: {
                    connectorAllowed: false,
                    enabled: false
                },
                marker: {
                    enabled: false
                }
            },
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    xAxis: {
                        max: null,
                        min: thirtydaysago(seriesData.data)
                    }
                }
            }]
        },

        series: seriesData.data
    }

    return (
        <div>
            <HighchartWithLoadingSpinner loaded={storeData}
                options={options} dataLength={seriesData.data.length} />
            <FigureCaption short_caption={'Percentage of area under smoke plumes.'} caption={'Percentage of overall area under smoke plumes. (100% = entire area) Smoke plumes from the NOAA Hazard Mapping System based on satellite observations. Smoke plume extents do not generally translate into on the ground impacts (smoke can be aloft) but provide a sense of potential smoke impacts areas.'} />
            <br />
        </div>
    )
})
